// Modelo Compañia para administrador.
export default class AnexoActivity {
    id=""
    description=""
    file=""
    filePath=""
    fileName=""
    fileType=""
    date=""
    activity=""
}



// WEBPACK FOOTER //
// ./src/model/AnexoActivity.js